export const COLLECT_OPT_INS_GET_FLOW_REQUEST = 'COLLECT_OPT_INS_GET_FLOW_REQUEST'
export const COLLECT_OPT_INS_GET_FLOW_RESPONSE = 'COLLECT_OPT_INS_GET_FLOW_RESPONSE'
export const COLLECT_OPT_INS_GET_FLOW_ERROR = 'COLLECT_OPT_INS_GET_FLOW_ERROR'
